import { Injectable, inject } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';

import { SvgIconNameInNamespaceByUrlPipe } from '@shared/svg-icons/pipes/svg-icon-name-in-namespace-by-url.pipe';

@Injectable()
export class MatIconService {
  readonly #matIconRegistry = inject(MatIconRegistry);
  readonly #domSanitizer = inject(DomSanitizer);
  readonly #svgIconNameInNamespaceByUrlPipe = inject(
    SvgIconNameInNamespaceByUrlPipe
  );

  addSvgIconsInNamespaceByUrl(iconUrls: string[], namespace: string): void {
    iconUrls.forEach(x => {
      this.#matIconRegistry.addSvgIconInNamespace(
        namespace,
        this.#svgIconNameInNamespaceByUrlPipe.transform(x),
        this.#domSanitizer.bypassSecurityTrustResourceUrl(x)
      );
    });
  }
}
